/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');
window.moment = require('moment');
window.numeral = require('numeral');
window.ColorScheme = require('color-scheme');
window.slugify = require('slugify');

window.numeral = require('numeral');

import BootstrapVue from 'bootstrap-vue';
Vue.use(BootstrapVue);

import Vuelidate from 'vuelidate'; // validation form field
Vue.use(Vuelidate);

import VueBootstrapTypeahead from 'vue-bootstrap-typeahead';
Vue.component('vue-bootstrap-typeahead', VueBootstrapTypeahead);

import VCalendar from 'v-calendar';
Vue.use(VCalendar);

import ToggleButton from 'vue-js-toggle-button';
Vue.use(ToggleButton);

import draggable from 'vuedraggable';
Vue.component('draggable', draggable);

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/ms';
Vue.use(DatePicker);

window.validators = require('vuelidate/lib/validators');

Vue.component('select2', require('./components/Select2.vue').default);
Vue.component('datepicker', require('./ui/DatePicker.vue').default);
Vue.component('monthly-fee-bar-chart', require('./components/MonthlyFeeBarComponent.vue').default);
Vue.component('member-datatable-component', require('./components/MemberDatatableComponent.vue').default);

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

//Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

/*const app = new Vue({
    el: '#app',
});*/

$(document).ready(function() {
    $('[data-toggle="tooltip"]').tooltip();
});
